import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";

import { getRouteByLink } from "./config/clientDetailsRoutes";
import PageRenderer from "./Pages/PageRenderer";

export const ClientDetailsRouter = () => {
  const { section, slug } = useParams<{
    section: string;
    slug?: string;
  }>();

  const selectedRoute = getRouteByLink(section ?? "");

  useEffect(() => {
    let sectionTitle = selectedRoute?.title ?? "Client detail";
    if (slug) {
      const slugTitle = slug.charAt(0).toUpperCase() + slug.slice(1).replace(/-/g, " ");
      sectionTitle = `${sectionTitle} - ${slugTitle}`;
    }
    document.title = sectionTitle;
  }, [section, slug, selectedRoute]);

  const renderContent = () => {
    if (!selectedRoute) {
      return (
        <div style={{ padding: "32px", textAlign: "center" }}>
          <Typography variant="body2" color="text.secondary" style={{ marginTop: "8px" }}>
            This section is not yet implemented. Add it in config/clientDetailsRoutes.tsx.
          </Typography>
        </div>
      );
    }

    // Multi-section page: use PageRenderer to compose sections
    if (selectedRoute.sections) {
      return (
        <PageRenderer
          sections={selectedRoute.sections}
          widthMode={selectedRoute.widthMode}
          sectionGap={selectedRoute.sectionGap}
        />
      );
    }

    // Single-component page: apply layout based on width mode
    if (selectedRoute.component) {
      const component = selectedRoute.component;
      if (selectedRoute.widthMode === "full") {
        return component;
      }
      return <Box data-testid="constrained-section" sx={{ maxWidth: "1000px", mx: "auto" }}>{component}</Box>;
    }

    return null;
  };

  return <div>{renderContent()}</div>;
};
